module.exports = __webpack_public_path__ + "fonts/TikTokTextRegular.c161d50a.otf";